import React, { Component } from 'react'
import _ from 'lodash'

import axios from 'axios';
import withTracker from "../containers/Full/withTracker";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Rating from 'react-rating';
import { Badge, Button } from 'reactstrap';


import '../styles/requestForm.css';
import {review, reviewStatusBuyerCheck, reviewStatusSellerCheck} from '../modules/actions/review';
import {request} from '../modules/actions/request';
import Swal from "sweetalert2";

class ReviewForm extends React.Component {
    constructor(props){
        super(props);
        this.keywords = ['friendly', 'cool', 'professional', 'always on time', 'flexible', 'quick response', 'fun', 'respectful', 'reliable', 'knowledgeable', 'thoughtful' ];
        this.state = {
            date: this.props.selectedDate,
            // sellerId: this.props.request.sellerId ? this.props.request.sellerId : this.props.request.userId,
            // buyerId: this.props.request.buyerId ? this.props.request.buyerId : this.props.request.userId,
            // recipientId :
            requestId: this.props.request.requestId,
            score: 0,
            // keywordSelected: false,
            // friendly: false
        };
        // this.handleClick = this.handleClick.bind(this);
    }


    // handleClick(event) {
    //     this.setState({score: undefined});
    // }

    handleRatingChange(score){
        // let rating = score;
        // console.log("event", score);
        //

        this.setState({score}, ()=>{
            console.log("this.state.score", this.state.score);
        });

        //callback해서 score가 state되기를 기다려야 함

        // console.log("this.state.score", this.state.score);
        // console.log('values ', values);
        // console.log(event.target.name);
        // values[event.target.name] = event.target.value;
        // this.setState(values);
        // console.log('values target',values, this.state);
    }

    handleChange(event){
        let values = this.state;
        // console.log('values ', values);
        console.log("handlechange event target",event.target.value);
        values[event.target.name] = event.target.value;
        this.setState(values);
        console.log('values', values);
    }

     submitReview(){

        let keywords = [];
        this.keywords.map((keyword)=>{
            if (this.state[keyword])
                keywords.push(keyword);
        });


        //{keywords, ...this.state}랑 this.state를 다 가져온 것에 keywords를 append한 것임
        this.props.dispatch(review({keywords, ...this.state}))
            .then((result)=>{
                console.log("what is review??", result);
                if(result.status==="Success"){
                    console.log("this props user type", this.props.user.type === "Buyer", this.props.user.type === "Buyer")
                    if(this.props.user.type === "Buyer"){
                        let payload={
                            "requestId": this.state.requestId,
                            "isSellerReviewed": true,
                        };
                        this.props.dispatch(reviewStatusSellerCheck(payload));
                    }else{
                        let payload={
                            "requestId": this.state.requestId,
                            "isBuyerReviewed": true,
                        };
                        this.props.dispatch(reviewStatusBuyerCheck(payload));
                    }


                    Swal.fire({
                        title: 'Success!',
                        text: 'Your review is sent successfully.',
                        type: 'success',
                        confirmButtonText: 'close'
                    })
                        .then(()=>{
                            console.log("Dismissed");
                            window.location.assign('/dashboard/history');
                        });
                }
            })


         //이 부분이랑 결국 같다
         // let payload = this.state;
         // console.log(payload);
         // payload.keywords = keywords;
         // console.log(payload);
         //
         // this.props.dispatch(review(payload))
         //     .then((result)=>{
         //         console.log("what is request??", result);
         //     })
    }

    onClick(tag) {
        console.log("Tag",tag);
        this.setState({[tag] : !this.state[tag]},()=>{ //**** so smart!!!!
            if(this.state[tag]){
                console.log("clicked");
            }else{
                console.log("unclicked");
            }
        });

    }

    render() {
        console.log("this props request",this.props.request);
        console.log("this props user", this.props.user.type === 'Buyer');
        console.log("This state", this.state);

        return (
            <div className="popup">
                <div className="popup_inner">
                    <div className="request-title">
                        Review to {this.props.userName}
                    </div>
                    <form style={{ marginTop: '10px', height: '80%' }}>
                        <div className="container-fluid">
                            <strong>Score:</strong>
                            <br />
                            {/*{this.state.score}*/}
                            <Rating
                                emptySymbol="fa fa-star-o fa-2x"
                                fullSymbol="fa fa-star fa-2x"
                                // placeholderSymbol="fa fa-star fa-2x"
                                fractions={2}
                                name="score"
                                initialRating={this.state.score}
                                onChange={this.handleRatingChange.bind(this)}
                                // placeholderRating={this.state.score}
                            />
                            <br />

                            {/*explain {username}*/}
                            <strong>Keyword:</strong><div>Choose multiple keywords that explain {this.props.userName} most</div>

                            {/* 1.하나씩*/}
                           {/* <Badge name="friendly" keyword="friendly" color="info" pill className="badge" style={{fontSize: 20}}*/}
                           {/* //        onClick={(event)=>{*/}
                           {/* //            console.log(event.target.keyword);*/}
                           {/* //            console.log(event.target.getAttribute("keyword"));*/}
                           {/* //     let values = 'friendly';*/}
                           {/* //     console.log('values', values, 'this props value??', this.props.value, 'just value', event.target);*/}
                           {/* //     // values[event.target.name] = event.target.value;*/}
                           {/* //     this.setState((values)=> {console.log(this.state.values)});*/}
                           {/* //     // console.log("second values", this.state.values);*/}
                           {/* // }}*/}
                           {/*//  onClick={this.onClick.bind(null, "friendly")*/}
                           {/*//      assign a function to onClick handler*/}
                           {/*     onClick={()=>this.onClick("friendly")}*/}
                           {/*        // call function directly*/}
                           {/* >Friendly</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Cool</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Professional</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Always on time</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Flexible</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Quick response</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Fun</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Respectful</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Reliable</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Knowledgeable</Badge>*/}
                           {/* <Badge color="info" pill className="badge" style={{fontSize: 20}}>Thoughtful</Badge>*/}
                           {/* <br />*/}

                            {/* 2. Array로*/}
                            {
                                this.keywords.map((keyword)=>{
                                    return (
                                        <Badge
                                            key={"tag-"+keyword}
                                            name={keyword} color={this.state[keyword] ? "danger" : "info"} pill
                                               className="badge"
                                               onClick={()=>this.onClick(keyword)}
                                        ><span className="keyword-text">
                                            {keyword}
                                        </span></Badge>
                                    )
                                })
                            }
                            <br />

                            <strong>Comment:</strong>
                            <br />
                            <textarea
                                name="comment" id="comment"
                                placeholder="How was it?"
                                style={{ width: '100%', height: '15vh' }}
                                onChange={this.handleChange.bind(this)}
                            />
                        </div>
                    </form>
                    <div className="form-button">
                        <button className="submit-button"
                                onClick={this.submitReview.bind(this)}>
                            Submit
                        </button>
                        <button className="cancel-button"
                            onClick={this.props.closeForm}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(store){
    return {
        user: store.auth.user,
    };
}

export default withRouter(connect(mapStateToProps)(ReviewForm));
